import axios from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    brands: [],
    selectedBrand: null,
  },
  getters: {
    getBrands: state => state.brands,
    getSelectedBrand: state => state.selectedBrand,
  },
  mutations: {
    UPDATE_BRANDS(state, val) {
      state.brands = val
    },
    UPDATE_SELECTED_BRAND(state, val) {
      state.selectedBrand = val
    },
  },
  actions: {
    fetchWelcomeBox(context, query) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/welcome-box/${query.company}`, {
            headers: {
              // Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZGluX2Rhc2gifQ.EByQxie39Qs6TTJSc8efcvxQzoY2YAMCk3q87MsVeAE',
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
            },
            params: {
              user: query.name,
            },
          })
          .then(response => {
            context.commit('UPDATE_BRANDS', ['all', ...response.data.brandFilter])
            if (!context.state.selectedBrand) {
              context.commit('UPDATE_SELECTED_BRAND', 'all')
            }
            return resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchScores(context, query) {
      return new Promise((resolve, reject) => {
        axios
          .get('/all-scores' + `/${query.company}/${query.brand}`, {
            headers: {
              // Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZGluX2Rhc2gifQ.EByQxie39Qs6TTJSc8efcvxQzoY2YAMCk3q87MsVeAE',
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAdEfficiencies(context, query) {
      const params = {}
      if (query.start) { params.start = query.start }
      if (query.end) { params.end = query.end }

      // console.log(params);
      return new Promise((resolve, reject) => {
        axios
          .get('/adin-score' + `/${query.company}/${query.brand}`, {
            headers: {
              // Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZGluX2Rhc2gifQ.EByQxie39Qs6TTJSc8efcvxQzoY2YAMCk3q87MsVeAE',
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
            },
            params,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchLeaderboards(context, company) {
      return new Promise((resolve, reject) => {
        axios
          .get('/top' + `/${company}`, {
            headers: {
              // Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZGluX2Rhc2gifQ.EByQxie39Qs6TTJSc8efcvxQzoY2YAMCk3q87MsVeAE',
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchHighlights(context, query) {
      return new Promise((resolve, reject) => {
        axios
          .get('/highlights' + `/${query.company}`, {
            headers: {
              // Authorization: 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZGluX2Rhc2gifQ.EByQxie39Qs6TTJSc8efcvxQzoY2YAMCk3q87MsVeAE',
              Accept: '*/*',
              'Access-Control-Allow-Origin': '*',
            },
            params: {
              brand: query.brand,
            },
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
